// E-Learning (Learner Portal) Routes - Procuring Entity UI
export default [
  {
    path: '/elearning/students/browse-courses',
    name: 'pe-browse-courses',
    meta: {
      authRequired: true,
      title: 'Browse Courses',
      breadcrumb: [
        { text: 'Dashboard', to: '/dashboard' },
        { text: 'E-Learning', active: true },
        { text: 'Browse Courses', active: true },
      ],
    },
    component: () => import('@/views/elearning/students/browse-courses.vue'),
  },
  {
    path: '/elearning/students/my-courses',
    name: 'pe-my-courses',
    meta: {
      authRequired: true,
      title: 'My Courses',
      breadcrumb: [
        { text: 'Dashboard', to: '/dashboard' },
        { text: 'E-Learning', active: true },
        { text: 'My Courses', active: true },
      ],
    },
    component: () => import('@/views/elearning/students/my-courses.vue'),
  },
  {
    path: '/elearning/students/course/:id',
    name: 'pe-course-student-view',
    meta: {
      authRequired: true,
      title: 'Course',
      breadcrumb: [
        { text: 'Dashboard', to: '/dashboard' },
        { text: 'E-Learning', to: '/elearning/students/my-courses' },
        { text: 'Course', active: true },
      ],
    },
    component: () => import('@/views/elearning/course-student-view.vue'),
  },
  {
    path: '/elearning/lessons/view/:id',
    name: 'pe-view-lesson',
    meta: {
      authRequired: true,
      title: 'View Lesson',
    },
    component: () => import('@/views/elearning/view-lesson.vue'),
  },
  {
    path: '/elearning/view-assessment',
    name: 'pe-view-assessment',
    meta: {
      authRequired: true,
      title: 'Assessment',
      breadcrumb: [
        { text: 'Dashboard', to: '/dashboard' },
        { text: 'E-Learning', to: '/elearning/students/my-courses' },
        { text: 'Assessment', active: true },
      ],
    },
    component: () => import('@/views/elearning/view-assessment.vue'),
  },
];
